/* === Elite Hockey — Sticky Add to Cart Bar JS === */
(function () {
  if (window.innerWidth > 749) return;

  var bar = document.getElementById('eh-sticky-atc');
  var btn = document.getElementById('eh-sticky-atc-btn');
  var priceEl = document.getElementById('eh-sticky-price');
  if (!bar) return;

  // Show bar after scrolling past 60% of viewport height
  function showHide() {
    var scroll = window.scrollY || window.pageYOffset;
    var threshold = window.innerHeight * 0.6;
    if (scroll > threshold) {
      bar.classList.add('visible');
    } else {
      bar.classList.remove('visible');
    }
  }
  window.addEventListener('scroll', showHide, { passive: true });

  // Clicking sticky button triggers the main product form submit
  if (btn) {
    btn.addEventListener('click', function () {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) { submitBtn.click(); }
      }
    });
  }

  // Update price if variant changes
  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant) return;
    var variant = e.detail.variant;
    if (priceEl && variant.price) {
      var formatted = (variant.price / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
      priceEl.textContent = formatted;
    }
    if (btn) {
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  });
})();
